module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-exclusives-3-8a3cccb9f3ae13fc9b7f6f7ac802b861.jpg";